import { IonText } from "@ionic/react";
import { ComponentProps } from "react";

import DateStamp from "@components/dates/DateStamp";
import styles from "@components/text/TextSizes.module.css";

type Props = ComponentProps<typeof IonText> & {
  date: number;
  month: number;
  year: number;
};

const DateGroupBanner = ({ date, month, year, ...textProps }: Props) => {
  const showYear = year !== new Date().getFullYear();

  return (
    <IonText className={styles.dateGroupBanner} {...textProps}>
      <DateStamp absoluteDate showYear={showYear} value={new Date(year, month, date)} />
    </IonText>
  );
};

export default DateGroupBanner;
